import { api } from '../api'
import accountsApi from '../../account/api'
import { DepositType } from '@deposits/const'
import { mapActions, mapState } from 'pinia'
import { useDepositStore } from '@deposits/store/depositStore'
import { provideApolloClient, useLazyQuery } from '@vue/apollo-composable'
import { LoadAccountsQueryForBankInputMixin } from '@/graphql/queries/deposit.queries'
import { apolloClient } from '@/graphql'

export default {
  data () {
    return {
      validatedAccounts: [],
      savingsDepoIbans: [],
      currentAccountIbans: []
    }
  },
  computed: {
    ...mapState(useDepositStore, ['featureFlags']),
    internalAccounts () {
      const accounts = []

      if (Array.isArray(this.currentAccountIbans) && this.currentAccountIbans.length > 0) {
        accounts.push({
          text: this.$pgettext('choosing_iban_curr', 'Current account'),
          options: this.currentAccountIbans
        })
      }

      if (Array.isArray(this.savingsDepoIbans) && this.savingsDepoIbans.length > 0) {
        accounts.push({
          text: this.$pgettext('choosing_iban', 'Savings deposit account'),
          options: this.savingsDepoIbans
        })
      }

      return accounts
    },
    bankInputTranslations () {
      return {
        externalAccounts: this.$pgettext('choosing_iban', 'External accounts')
      }
    }
  },
  methods: {
    ...mapActions(useDepositStore, ['getPermittedIbanCountries', 'setPermittedIbansCountryCodes']),
    setSavingsDepoIbans (ibans) {
      this.savingsDepoIbans = ibans
    },
    setValidatedAccounts (accounts) {
      this.validatedAccounts = accounts
    },
    async loadAccounts (accountTypeCode) {
      let isHttpRequestsNeeded = true

      if (this.featureFlags.enableGraphQLExperimentalSupport) {
        provideApolloClient(apolloClient)

        const { load, onResult, onError } = useLazyQuery(LoadAccountsQueryForBankInputMixin, {
          input: { accountTypeCode }
        }, {
          fetchPolicy: 'no-cache'
        })

        onError((error) => {
          console.error(error)
        })

        onResult(({ data }) => {
          const { customerAccounts, permittedIbanCountries, savingsDepositIbans } = data

          this.setSavingsDepoIbans(savingsDepositIbans.map(({ value }) => {
            return { accountNumber: value }
          }))
          this.setValidatedAccounts(customerAccounts)
          this.setPermittedIbansCountryCodes(permittedIbanCountries.map(({ value }) => value))

          isHttpRequestsNeeded = false
        })

        await Promise.all([
          load(),
          /*
           Direct request to component-account. If you want make it in single operation, GraphQL in component--account also needed
           Plus, schema stitching in self-service chrome https://the-guild.dev/graphql/stitching
          */
          this.loadCurrentAccountsIbans()
        ])
      }

      if (isHttpRequestsNeeded) {
        const [validatedAccounts] = await Promise.all([
          api.getValidatedAccounts(),
          this.loadSavingsDepoIbans(),
          this.loadCurrentAccountsIbans(),
          this.getPermittedIbanCountries({ accountTypeCode })
        ])

        this.setValidatedAccounts(validatedAccounts)
      }
    },
    async loadCurrentAccountsIbans () {
      if (this.featureFlags.termDepositOutpaymentToCurrentAccount) {
        this.currentAccountIbans = (await accountsApi.getCurrentAccounts()).map(account => ({
          accountNumber: account.iban
        }))
        return this.currentAccountIbans
      }
    },
    async loadSavingsDepoIbans () {
      if (this.deposit?.depositType === DepositType.Demand) {
        return null
      }

      const ibans = (await api.getSavingsDepoIbans()).map(iban => ({
        accountNumber: iban
      }))

      this.setSavingsDepoIbans(ibans)
    }
  }
}
